module.exports = __webpack_public_path__ + "media/components/terrain-mapping/icons/Public transport-8ff09df2d06a4da713e2e7cdbcc67d8b.png";